export default __webpack_public_path__ + "static/media/gabinet_mov.bad55ea3.mov";